'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import type { FilterOption } from '../../constants';
import { FESTIVAL_MONTH_OPTIONS, FESTIVAL_RADIUS_OPTIONS } from '../../constants';
import { FilterChipRadioGroup } from '../FilterChipRadioGroup';
import { FilterDrawerShell } from '../FilterDrawerShell';
import { FilterMonthGrid } from '../FilterMonthGrid';
import { FilterSection } from '../FilterSection';
import { FilterSelectableList } from '../FilterSelectableList';
import { FilterSidebarShell } from '../FilterSidebarShell';
import { RegionFilterDialog, RegionFilterField } from '../RegionFilterField';

/** 한국관광공사 분류체계 1depth — 축제/공연/행사 */
const FESTIVAL_LCLS_SYSTM1_CODE = 'EV';
const REGION_DIALOG_TITLE = '축제를 볼 지역을 선택해 주세요';
const REGION_WHOLE_COUNTRY_HINT = '시·군·구까지 좁히면 반경을 지정해 가까운 축제만 볼 수 있어요.';
const RADIUS_DISABLED_HINT = '시·군·구를 선택하면 반경을 지정할 수 있어요.';
interface FestivalFilterProps {
  isDrawerOpen: boolean;
  onCloseDrawer: () => void;
  onApplyDrawer: () => void;
  lclsSystm2: string | null;
  onSelectLclsSystm2: (code: string | null) => void;
  regionCode: string | null;
  subRegionCode: string | null;
  onSelectRegion: (code: string | null) => void;
  onSelectSubRegion: (code: string | null) => void;
  radius: number;
  onSelectRadius: (radius: number | null) => void;
  month: number | null;
  onSelectMonth: (month: number | null) => void;
  onReset: () => void;
}
export function FestivalFilter(t0) {
  const $ = _c(84);
  const {
    isDrawerOpen,
    onCloseDrawer,
    onApplyDrawer,
    lclsSystm2,
    onSelectLclsSystm2,
    regionCode,
    subRegionCode,
    onSelectRegion,
    onSelectSubRegion,
    radius,
    onSelectRadius,
    month,
    onSelectMonth,
    onReset
  } = t0;
  const [isRegionDialogOpened, setIsRegionDialogOpened] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...UnauthQueryOptions["get:/wello/v1/allows/tour/lcls-systm-code"]({
        query: {
          depth: 2
        }
      }),
      staleTime: Infinity,
      gcTime: Infinity,
      select: _temp4
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: t2,
    isLoading: isCategoryLoading
  } = useQuery(t1);
  let t3;
  if ($[1] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const categoryOptions = t3;
  let t4;
  if ($[3] !== categoryOptions || $[4] !== isCategoryLoading || $[5] !== lclsSystm2 || $[6] !== onSelectLclsSystm2) {
    t4 = <FilterSection title={"\uCE74\uD14C\uACE0\uB9AC"}><FilterSelectableList options={categoryOptions} selectedValue={lclsSystm2} onSelect={onSelectLclsSystm2} allowClear={true} isLoading={isCategoryLoading} skeletonCount={3} /></FilterSection>;
    $[3] = categoryOptions;
    $[4] = isCategoryLoading;
    $[5] = lclsSystm2;
    $[6] = onSelectLclsSystm2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== month || $[9] !== onSelectMonth) {
    t5 = <FilterSection title={"\uC6D4"}><FilterMonthGrid selectedMonth={month} onSelectMonth={onSelectMonth} /></FilterSection>;
    $[8] = month;
    $[9] = onSelectMonth;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== onSelectRegion || $[12] !== onSelectSubRegion || $[13] !== regionCode || $[14] !== subRegionCode) {
    t6 = <FilterSection title={"\uC9C0\uC5ED"}><RegionFilterField regionCode={regionCode} subRegionCode={subRegionCode} onRegionChange={onSelectRegion} onSubRegionChange={onSelectSubRegion} title={REGION_DIALOG_TITLE} wholeCountryHint={REGION_WHOLE_COUNTRY_HINT} /></FilterSection>;
    $[11] = onSelectRegion;
    $[12] = onSelectSubRegion;
    $[13] = regionCode;
    $[14] = subRegionCode;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== subRegionCode) {
    t7 = subRegionCode ? null : <p className="m-0 text-Gray-600 typo-caption1">{RADIUS_DISABLED_HINT}</p>;
    $[16] = subRegionCode;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = subRegionCode ? radius : null;
  const t9 = !subRegionCode;
  let t10;
  if ($[18] !== onSelectRadius || $[19] !== t8 || $[20] !== t9) {
    t10 = <FilterSelectableList options={FESTIVAL_RADIUS_OPTIONS} selectedValue={t8} onSelect={onSelectRadius} disabled={t9} />;
    $[18] = onSelectRadius;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7) {
    t11 = <FilterSection title={"\uBC18\uACBD"}>{t7}{t10}</FilterSection>;
    $[22] = t10;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== onReset || $[26] !== t11 || $[27] !== t4 || $[28] !== t5 || $[29] !== t6) {
    t12 = <FilterSidebarShell onReset={onReset}>{t4}{t5}{t6}{t11}</FilterSidebarShell>;
    $[25] = onReset;
    $[26] = t11;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <h3 className="font-700 text-Gray-900 typo-body4">카테고리</h3>;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== categoryOptions || $[33] !== isCategoryLoading || $[34] !== lclsSystm2 || $[35] !== onSelectLclsSystm2) {
    t14 = <div className="flex flex-col gap-12">{t13}<FilterChipRadioGroup options={categoryOptions} selectedValue={lclsSystm2} onSelect={onSelectLclsSystm2} isLoading={isCategoryLoading} skeletonCount={3} /></div>;
    $[32] = categoryOptions;
    $[33] = isCategoryLoading;
    $[34] = lclsSystm2;
    $[35] = onSelectLclsSystm2;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <h3 className="font-700 text-Gray-900 typo-body4">월</h3>;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== month || $[39] !== onSelectMonth) {
    t16 = <div className="flex flex-col gap-12">{t15}<FilterChipRadioGroup options={FESTIVAL_MONTH_OPTIONS} selectedValue={month} onSelect={onSelectMonth} /></div>;
    $[38] = month;
    $[39] = onSelectMonth;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <h3 className="font-700 text-Gray-900 typo-body4">지역</h3>;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== isRegionDialogOpened || $[43] !== onSelectRegion || $[44] !== onSelectSubRegion || $[45] !== regionCode || $[46] !== subRegionCode) {
    t18 = <div className="flex flex-col gap-12">{t17}<RegionFilterField regionCode={regionCode} subRegionCode={subRegionCode} onRegionChange={onSelectRegion} onSubRegionChange={onSelectSubRegion} title={REGION_DIALOG_TITLE} wholeCountryHint={REGION_WHOLE_COUNTRY_HINT} dialogOpened={isRegionDialogOpened} onDialogOpenChange={setIsRegionDialogOpened} renderDialog={false} /></div>;
    $[42] = isRegionDialogOpened;
    $[43] = onSelectRegion;
    $[44] = onSelectSubRegion;
    $[45] = regionCode;
    $[46] = subRegionCode;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <h3 className="font-700 text-Gray-900 typo-body4">반경</h3>;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== subRegionCode) {
    t20 = subRegionCode ? null : <p className="m-0 text-Gray-600 typo-caption1">{RADIUS_DISABLED_HINT}</p>;
    $[49] = subRegionCode;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  const t21 = !subRegionCode && "pointer-events-none opacity-40";
  let t22;
  if ($[51] !== t21) {
    t22 = cn(t21);
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  const t23 = subRegionCode ? radius : null;
  let t24;
  if ($[53] !== onSelectRadius || $[54] !== t23) {
    t24 = <FilterChipRadioGroup options={FESTIVAL_RADIUS_OPTIONS} selectedValue={t23} onSelect={onSelectRadius} />;
    $[53] = onSelectRadius;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t22 || $[57] !== t24) {
    t25 = <div className={t22}>{t24}</div>;
    $[56] = t22;
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t20 || $[60] !== t25) {
    t26 = <div className="flex flex-col gap-12">{t19}{t20}{t25}</div>;
    $[59] = t20;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== t14 || $[63] !== t16 || $[64] !== t18 || $[65] !== t26) {
    t27 = <div className="flex flex-col gap-24">{t14}{t16}{t18}{t26}</div>;
    $[62] = t14;
    $[63] = t16;
    $[64] = t18;
    $[65] = t26;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== isDrawerOpen || $[68] !== onApplyDrawer || $[69] !== onCloseDrawer || $[70] !== onReset || $[71] !== t27) {
    t28 = <FilterDrawerShell isOpen={isDrawerOpen} onReset={onReset} onApply={onApplyDrawer} onClose={onCloseDrawer}>{t27}</FilterDrawerShell>;
    $[67] = isDrawerOpen;
    $[68] = onApplyDrawer;
    $[69] = onCloseDrawer;
    $[70] = onReset;
    $[71] = t27;
    $[72] = t28;
  } else {
    t28 = $[72];
  }
  let t29;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = () => setIsRegionDialogOpened(false);
    $[73] = t29;
  } else {
    t29 = $[73];
  }
  let t30;
  if ($[74] !== isRegionDialogOpened || $[75] !== onSelectRegion || $[76] !== onSelectSubRegion || $[77] !== regionCode || $[78] !== subRegionCode) {
    t30 = <RegionFilterDialog opened={isRegionDialogOpened} onClose={t29} regionCode={regionCode} subRegionCode={subRegionCode} onRegionChange={onSelectRegion} onSubRegionChange={onSelectSubRegion} title={REGION_DIALOG_TITLE} wholeCountryHint={REGION_WHOLE_COUNTRY_HINT} />;
    $[74] = isRegionDialogOpened;
    $[75] = onSelectRegion;
    $[76] = onSelectSubRegion;
    $[77] = regionCode;
    $[78] = subRegionCode;
    $[79] = t30;
  } else {
    t30 = $[79];
  }
  let t31;
  if ($[80] !== t12 || $[81] !== t28 || $[82] !== t30) {
    t31 = <>{t12}{t28}{t30}</>;
    $[80] = t12;
    $[81] = t28;
    $[82] = t30;
    $[83] = t31;
  } else {
    t31 = $[83];
  }
  return t31;
}
function _temp4(t0) {
  const {
    context
  } = t0;
  return (context ?? []).filter(_temp).map(_temp2).filter(_temp3);
}
function _temp3(item_1) {
  return item_1.value && item_1.label;
}
function _temp2(item_0) {
  return {
    value: item_0.code ?? "",
    label: item_0.value ?? ""
  };
}
function _temp(item) {
  return item.code?.startsWith(FESTIVAL_LCLS_SYSTM1_CODE);
}